import { useMemo } from 'react'

import plans from 'modules/billing/store/collections/plans'
import type Plan from 'modules/billing/store/models/Plan'
import { AVAILABLE_FAMILIES } from 'modules/billing/store/models/Plan'
import type { AvailableFamily } from 'modules/billing/store/models/Plan'

export interface AvailablePlans {
  month: Plan | null | undefined
  year: Plan | null | undefined
}

function findPlansOrRaise(loadingPlans: boolean, family: AvailableFamily): AvailablePlans {
  if (loadingPlans) {
    return {
      month: null,
      year: null,
    }
  }

  const month = plans.find({
    interval: 'month',
    family,
  })

  const year = plans.find({
    interval: 'year',
    family,
  })

  if (!year) throw new Error(`Yearly plan not found for ${family}`)

  return {
    month,
    year,
  }
}

interface FamilyPlans {
  essentials: AvailablePlans
  premium: AvailablePlans
}

const usePlans = (loadingPlans = false): FamilyPlans => {
  return useMemo<FamilyPlans>(
    () => ({
      essentials: findPlansOrRaise(loadingPlans, AVAILABLE_FAMILIES.essentials ?? ''),
      premium: findPlansOrRaise(loadingPlans, AVAILABLE_FAMILIES.premium ?? ''),
    }),
    [loadingPlans]
  )
}

export default usePlans
